<span (click)="openModal(); $event.stopPropagation()">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</span>
